import { apiClient } from "@/lib/api/axios";
import type { NotificationPage } from "../types";

export interface ListNotificationsParams {
  unread?: boolean;
  limit?: number;
  cursor?: string;
}

/**
 * O feed é roteado pela FACHADA do crm-api (hub#340): o front fala só com o
 * crm-api (caminho relativo resolvido por `apiClient.baseURL` / `VITE_API_BASE_URL`)
 * e não conhece o host do serviço central. O crm-api repassa o Bearer do corretor;
 * o interceptor do axios anexa o token (ver `@/lib/api/axios`).
 */

/** Histórico persistido do corretor (mais novas primeiro; cursor por id). */
export async function listNotifications(params?: ListNotificationsParams): Promise<NotificationPage> {
  const { data } = await apiClient.get<NotificationPage>("/notifications", { params });
  return data;
}

/** Total de não lidas — usado pelo badge do sino sem carregar a lista. */
export async function getUnreadCount(): Promise<number> {
  const { data } = await apiClient.get<{ count: number }>("/notifications/unread-count");
  return data.count;
}

export async function markNotificationRead(id: string): Promise<void> {
  await apiClient.post(`/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiClient.post("/notifications/read-all");
}

export async function deleteNotification(id: string): Promise<void> {
  await apiClient.delete(`/notifications/${id}`);
}
